import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Row, Col, Tag, Divider } from 'antd';
import { FormattedMessage } from 'react-intl';

export const HowDoesItWork = () => {
  return (
    <>
      <Row justify='center' style={{ margin: '40px auto' }}>
        <Col
          xl={20}
          sm={22}
          style={{
            background: '#fff',
            padding: 40,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
          }}
        >
          <div style={{ marginBottom: 40 }}>
            <Tag
              style={{
                background: '#5BBCBD',
                color: '#fff',
                border: 'none',
                fontWeight: 'bolder'
              }}
            >
              <FormattedMessage id='landing.how.label'/>
            </Tag>
          </div>
          {/* 5 STEP PROCESS */}
          <Row justify='space-between' gutter={[24, 24]}>
            {/* ENROLL */}
            <Col
              xl={4}
              sm={24}
              style={{
                color: '#fff',
                padding: 20,
                borderRadius: 18,
                height: 260,
                background: '#D7753E',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
              }}
            >
              <strong style={{ fontSize: 18, color: '#fff' }}><FormattedMessage id='landing.how.enroll-card.title'/></strong>
              <br />
              <br />
              <p>
                <FormattedMessage id='landing.how.enroll-card.description'/>
              </p>
              <RightOutlined
                style={{ position: 'absolute', bottom: 15, right: 15 }}
              />
            </Col>
            {/* COHORTS */}
            <Col
              xl={4}
              sm={24}
              style={{
                color: '#fff',
                padding: 20,
                borderRadius: 18,
                height: 260,
                background: '#8053D7',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
              }}
            >
              <strong style={{ fontSize: 18, color: '#fff' }}>
                <FormattedMessage id='landing.how.cohort-card.title'/>
              </strong>
              <br />
              <br />
              <p><FormattedMessage id='landing.how.cohort-card.description'/></p>
              <RightOutlined
                style={{ position: 'absolute', bottom: 15, right: 15 }}
              />
            </Col>
            {/* QUESTIONS */}
            <Col
              xl={4}
              sm={24}
              style={{
                color: '#fff',
                padding: 20,
                borderRadius: 18,
                height: 260,
                background: '#5BBCBD',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
              }}
            >
              <strong style={{ fontSize: 18, color: '#fff' }}>
                <FormattedMessage id='landing.how.questions-card.title'/>
              </strong>
              <br />
              <br />
              <p>
                <FormattedMessage id='landing.how.questions-card.description'/>
              </p>
              <RightOutlined
                style={{ position: 'absolute', bottom: 15, right: 15 }}
              />
            </Col>
            {/* INTERVALS */}
            <Col
              xl={4}
              sm={24}
              style={{
                color: '#fff',
                padding: 20,
                borderRadius: 18,
                height: 260,
                background: '#E5A84F',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
              }}
            >
              <strong style={{ fontSize: 18, color: '#fff' }}>
                <FormattedMessage id='landing.how.intervals-card.title'/>
              </strong>
              <br />
              <br />
              <p>
                <FormattedMessage id='landing.how.intervals-card.description'/>
              </p>
              <RightOutlined
                style={{ position: 'absolute', bottom: 15, right: 15 }}
              />
            </Col>
            {/* PROGRESS */}
            <Col
              xl={4}
              sm={24}
              style={{
                color: '#fff',
                padding: 20,
                borderRadius: 18,
                height: 260,
                background: '#FFDC54',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
              }}
            >
              <strong style={{ fontSize: 18, color: '#333' }}>
                <FormattedMessage id='landing.how.progress-card.title'/>
              </strong>
              <br />
              <br />
              <p style={{ color: '#333' }}>
                <FormattedMessage id='landing.how.progress-card.description'/>
              </p>
              <RightOutlined
                style={{ position: 'absolute', bottom: 15, right: 15, color: '#333' }}
              />
            </Col>
          </Row>
          <Divider dashed style={{ background: '#999' }} />
        </Col>
      </Row>
    </>
  );
};
